import config from './config'
import instance from './apiInstance'
import { parsePaintedPrice, urlKey } from './photoPrice'

let running = null

function tessFromCdn() {
  if (typeof window === 'undefined') return Promise.reject(new Error('no_window'))
  if (window.Tesseract?.createWorker) return Promise.resolve(window.Tesseract)
  return new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-tess]')
    if (existing) {
      existing.addEventListener('load', () => resolve(window.Tesseract))
      existing.addEventListener('error', () => reject(new Error('tess_cdn')))
      return
    }
    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js'
    script.async = true
    script.dataset.tess = '1'
    script.onload = () => resolve(window.Tesseract)
    script.onerror = () => reject(new Error('tess_cdn'))
    document.head.appendChild(script)
  })
}

async function blobFromProxy(url) {
  const res = await fetch(`${config.API_URL}/photo_proxy?url=${encodeURIComponent(url)}`)
  if (!res.ok) throw new Error(`proxy_${res.status}`)
  return res.blob()
}

async function clientOcr(urls) {
  const Tesseract = await tessFromCdn()
  const worker = await Tesseract.createWorker('por+eng', 1, {
    workerPath: 'https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/worker.min.js',
    corePath: 'https://cdn.jsdelivr.net/npm/tesseract.js-core@5/tesseract-core-simd.wasm.js',
    langPath: 'https://tessdata.projectnaptha.com/4.0.0',
  })
  const out = {}
  try {
    for (const url of urls) {
      try {
        let blob
        try {
          blob = await blobFromProxy(url)
        } catch {
          const res = await fetch(url)
          if (!res.ok) continue
          blob = await res.blob()
        }
        const { data } = await worker.recognize(blob)
        const parsed = parsePaintedPrice(data?.text || '')
        if (parsed.our_price) {
          out[url] = parsed.our_price
          out[urlKey(url)] = parsed.our_price
        }
      } catch {
        /* próxima peça */
      }
    }
  } finally {
    await worker.terminate()
  }
  return out
}

export async function resolveCartPhotoPrices(urls) {
  const unique = [...new Set((urls || []).map(urlKey).filter(Boolean))].slice(0, 12)
  if (!unique.length) return {}
  if (running) return running
  running = (async () => {
    let prices = {}
    try {
      const res = await instance.get('/photo_prices')
      prices = { ...prices, ...(res.data?.prices || {}) }
    } catch {
      /* índice vazio */
    }
    const missing = unique.filter((url) => prices[url] == null)
    if (missing.length) {
      try {
        const res = await instance.post('/photo_prices/resolve', { urls: missing }, { timeout: 90000 })
        prices = { ...prices, ...(res.data?.prices || {}) }
      } catch {
        /* Vercel sem tesseract — cai no OCR do aparelho */
      }
    }
    const still = unique.filter((url) => prices[url] == null)
    if (still.length) {
      try {
        prices = { ...prices, ...(await clientOcr(still)) }
      } catch {
        /* deixa "preço na foto" nessa peça */
      }
    }
    return prices
  })()
  try {
    return await running
  } finally {
    running = null
  }
}
